<template>
  <div>
    <a-form-model-item v-if="env">
      <a-select v-model="curEnv" placeholder="选择环境" @change="envChange">
        <a-select-option v-for="item in devOptions" :key="item" :value="item">
          {{ item }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item v-if="env && !logoUi.hostname">
      <a-select v-model="sysDev" placeholder="选择系统" @change="sysChange">
        <a-select-option v-for="item in devSystem" :key="item.name" :value="item.appId">
          {{ item.name }}
        </a-select-option>
      </a-select>
    </a-form-model-item>
  </div>
</template>

<script>
import { getLogo } from '@/utils/intConfiguration';
import {
  setUserEnv,
  rmToken,
  setUserSys,
  setUserZnEnv,
} from '../login-handler';

const { envList, system } = require('../../../../config/dev.proxy');

export default {
  name: 'Environment',

  data() {
    return {
      // eslint-disable-next-line global-require
      logoUi: getLogo(),
      curEnv: '',
      sysDev: '',
      devOptions: envList,
      devSystem: system,
    };
  },
  computed: {
    env() {
      let env = false;
      try {
        env = process.env.NODE_ENV === 'development';
      } catch (e) {
        env = false;
      }
      return env;
    },
  },

  mounted() {
    this.$root.$on('login-system-selected', this.syncSystem);
    if (this.env) {
      this.sysDev = localStorage.getItem('appId') || '';
      this.curEnv = localStorage.getItem('curEnv') || 'dev';
      setUserEnv(this.curEnv);
      setUserZnEnv(this.curEnv);
    }
  },
  beforeDestroy() {
    this.$root.$off('login-system-selected', this.syncSystem);
  },

  methods: {
    syncSystem(value) {
      this.sysDev = value;
    },
    envChange(value) {
      setUserEnv(value);
      setUserZnEnv(value);
      rmToken();
    },
    sysChange(value) {
      setUserSys(value);
      rmToken();
      this.$root.$emit('login-system-selected', value);
    },
  },
};
</script>
